import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import { NavLink, Stack, Text } from "@mantine/core";
import {
  IconUsers,
  IconShieldCheck,
  IconBuilding,
  IconHistory,
  IconHome,
  IconId,
  IconTruck,
  IconCar,
  IconUsersGroup,
  IconClipboardList,
  IconReportMoney,
  IconCashBanknote,
  type TablerIcon,
} from "@tabler/icons-react";
import { useAuth } from "@/lib/auth";

interface NavItem {
  to: string;
  label: string;
  icon: TablerIcon;
  perm?: string;
}

const items: NavItem[] = [
  { to: "/", label: "Главная", icon: IconHome },
  { to: "/orders", label: "Журнал заявок", icon: IconClipboardList, perm: "orders:read" },
  { to: "/users", label: "Пользователи", icon: IconUsers, perm: "users:manage" },
  { to: "/roles", label: "Роли и доступы", icon: IconShieldCheck },
  { to: "/companies", label: "Свои фирмы", icon: IconBuilding, perm: "companies:read" },
  { to: "/clients", label: "Заказчики", icon: IconUsersGroup, perm: "clients:read" },
  { to: "/carriers", label: "Перевозчики", icon: IconTruck, perm: "carriers:read" },
  { to: "/drivers", label: "Водители", icon: IconId, perm: "drivers:read" },
  { to: "/vehicles", label: "Транспорт", icon: IconCar, perm: "vehicles:read" },
  { to: "/reports/receivables", label: "Дебиторка", icon: IconReportMoney, perm: "orders:read" },
  { to: "/reports/payables", label: "Кредиторка", icon: IconCashBanknote, perm: "orders:read" },
  { to: "/audit", label: "Аудит", icon: IconHistory, perm: "audit:read" },
];

export function Sidebar() {
  const { hasPerm } = useAuth();
  const location = useLocation();
  return (
    <Stack gap={4} p="sm">
      <Text size="xs" c="dimmed" tt="uppercase" fw={700} px="xs" mb="xs">
        ЕвроМаркет
      </Text>
      {items.map((it) => {
        if (it.perm && !hasPerm(it.perm)) return null;
        const Icon = it.icon;
        const active =
          it.to === "/"
            ? location.pathname === "/"
            : location.pathname.startsWith(it.to);
        return (
          <NavLink
            key={it.to}
            component={RouterNavLink}
            to={it.to}
            label={it.label}
            leftSection={<Icon size={18} />}
            active={active}
            variant="filled"
          />
        );
      })}
    </Stack>
  );
}
